const helpMeg = r => require.ensure([], () => r(require('@/page/complaintAndHelp/helpMeg')), 'helpMeg');
const complaint = r => require.ensure([], () => r(require('@/page/complaintAndHelp/complaint/complaint.vue')), 'complaint');

export const helpMegRouter = {
    path: '',
    name: '技术咨询与帮助',
    component: helpMeg,
    meta: {
        icon: 'complaintMge',
        right: [],
        isShowMenu: false,
        keepAlive:true,
    },
    children: [{
            path: '/complaint',
            component: complaint,
            name: '技术咨询与帮助',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        

    ]
};
export default helpMegRouter;